import { createContext, useContext } from "react"

import { ClarificationRequest } from "shared/types/__generated__/graphql"

import { TeamMemberFragment } from "entities/team-members/graphql/fragments.generated"

interface ClarificationRequestFormContextType {
  clarificationRequest: ClarificationRequest | null
  isLoading?: boolean
  lastUpdatedByMember: TeamMemberFragment | null
}

export const ClarificationRequestFormContext =
  createContext<ClarificationRequestFormContextType>({
    clarificationRequest: null,
    isLoading: false,
    lastUpdatedByMember: null
  })

export function useClarificationRequestFormContext() {
  return useContext(ClarificationRequestFormContext)
}
